import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col, Alert } from 'react-bootstrap'
import hash from 'object-hash'
import isEmail from 'validator/lib/isEmail'
import SelectAppointmentModal from './select_appointment_modal'
import { Trans } from 'react-i18next'

const { t } = i18next

class ContractForm extends React.Component {
  static defaultProps = {
    business_role_priority: null,
    contact: null,
    pending: false,
    readonly: false,
    blockAppointment: false,
    onSave: () => {},
    closeForm: () => {},
  }

  state = {
    id: null,
    sig_name: '',
    appointment: null,
    contract_hash: '',
    dealer_brand_id: null,
  }

  initialHash = ''

  constructor(props) {
    super(props)
    if (props?.contract?.id) {
      let { id, appointment, email, sig_name, phone } = props.contract
      this.state.id = id
      this.state.appointment = appointment
      this.state.email = email || ''
      this.state.phone = phone || ''
      this.state.sig_name = sig_name || ''
    } else if (props?.contract?.appointment) {
      this.state.appointment = props?.contract?.appointment
    }

    // eslint-disable-next-line no-unused-vars
    let { contract_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.contract_hash = this.initialHash
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.contract === null && this.props.contract) {
      if (this.props?.contract?.id) {
        let { id, appointment, sig_name } = this.props.contract

        this.setState({
          id,
          appointment,
          sig_name: sig_name || '',
        })
      } else if (this.props?.contract?.appointment) {
        this.setState({ appointment: this.props?.contract?.appointment })
      }

      let { contract_hash, ...rest } = this.state
      this.initialHash = hash(rest)
      this.setState({ contract_hash: this.initialHash })
    }
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { contract_hash, ...rest } = this.state
    this.setState({ contract_hash: hash(rest) })
  }

  handleChangeAppointment = appointment => {
    this.setState({ appointment, dealer_brand_id: appointment.dealer_brand_id }, () => this.updateHash())
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { contract_hash, current_reference, ...rest } = this.state
    this.props.onSave(rest)
  }

  isFormValid = () => {
    let { appointment, sig_name } = this.state

    const requiredFieldsValid = appointment?.id && sig_name

    return requiredFieldsValid
  }

  isEmailInvalid = prop => {
    let [group, field] = prop.split('.')

    let current_value = group && field ? this.state?.[group]?.[field] ?? '' : this.state?.[group] ?? ''
    return current_value !== '' && !isEmail(current_value)
  }

  renderStatus = () => {
    const status = this.props?.contract?.status ?? 'pending'
    if (status === 'signed') {
      return <b className="text-success">{t('components.contracts.signed', 'Firmato')}</b>
    }
    if (status === 'expired') {
      return <b className="text-dark">{t('components.contracts.expired', 'Scaduto')}</b>
    }
    if (status === 'pending') {
      return <b className="text-warning">{t('components.contracts.pending', 'In attesa')}</b>
    }
    if (status === 'rejected') {
      return <b className="text-danger">{t('components.contracts.rejected', 'Rifiutato')}</b>
    }
    return status
  }

  render() {
    let { pending, readonly, contract, blockAppointment } = this.props
    let { id, appointment = null, sig_name } = this.state

    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <Row>
              <Form.Group as={Col} sm="12" className="mb-3">
                <SelectAppointmentModal
                  selected={appointment}
                  required={true}
                  multiSelection={false}
                  onChange={this.handleChangeAppointment}
                  readonly={readonly || id !== null || blockAppointment}
                  created_by={contract?.id && appointment?.created_by ? appointment.created_by : null}
                />
              </Form.Group>
            </Row>
            {appointment?.id && (
              <Row>
                <Alert variant="info">
                  <Alert.Heading>Informazioni del Dealer</Alert.Heading>
                  <div>
                    <span className="fw-bold me-2">
                      <Trans i18nKey="components.contracts.brand">Brand</Trans>:
                    </span>
                    {appointment.brand_name}
                  </div>
                  <div>
                    <span className="fw-bold me-2">
                      <Trans i18nKey="components.contracts.business_name">Ragione sociale</Trans>:
                    </span>
                    {appointment.dealer.business_name}
                  </div>
                  <div>
                    <span className="fw-bold me-2">
                      <Trans i18nKey="components.contracts.piva">Partita IVA</Trans>:
                    </span>
                    {appointment.dealer.piva}
                  </div>
                  <div>
                    <span className="fw-bold me-2">
                      <Trans i18nKey="components.contracts.address">Indirizzo</Trans>:
                    </span>
                    {appointment.dealer.address}
                  </div>
                </Alert>
              </Row>
            )}

            {/* <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.contracts.email">Email</Trans>
                  <span> *</span>
                </Form.Label>
                <Form.Control
                  name="email"
                  placeholder={t('components.contracts.email', 'Email')}
                  value={email}
                  onChange={this.handleChange}
                  isInvalid={this.isEmailInvalid('email')}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.contracts.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.contracts.phone">Telefono</Trans>
                  <span> *</span>
                </Form.Label>
                <Form.Control
                  name="phone"
                  placeholder={t('components.contracts.phone', 'Telefono')}
                  value={phone}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
            </Row> */}
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.contracts.sig_name">Firmatario</Trans>
                  <span> *</span>
                </Form.Label>
                <Form.Control
                  name="sig_name"
                  placeholder={t('components.contracts.sig_name', 'Firmatario')}
                  value={sig_name}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
            </Row>
            {contract?.status && (
              <Row>
                <Form.Group as={Col} md="6" sm="12" className="mb-3">
                  <Form.Label>
                    <Trans i18nKey="components.contracts.status">Stato</Trans>: {this.renderStatus()}
                  </Form.Label>
                </Form.Group>
              </Row>
            )}
          </div>
        </div>
        <div className="border-top pt-2">
          {readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.contract_hash || pending}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}

export default ContractForm
